<template>
  <pop-view @onCloseClick="onCloseClick">
    <div class="edit-device">
      <div class="edit-device-top">
        <p class="edit-device-top-title">设备档案</p>
        <img
          class="edit-device-top-close"
          src="@imgs/close-card.png"
          @click="onCloseClick"
        />
      </div>
      
      <div class="edit-device-tabs">
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 'basic' }"
          @click="activeTab = 'basic'"
        >
          设备基础信息
        </div>
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 'usage' }"
          @click="activeTab = 'usage'"
        >
          使用档案
        </div>
      </div>

      <div v-show="activeTab === 'basic'" class="edit-device-middle">
        <div class="edit-device-middle-model">
          <p class="edit-device-middle-model-title"><span class="required">*</span>型号：</p>
          <el-select
            v-model="selectedModelId"
            placeholder="请选择"
            class="edit-device-middle-model-select"
            disabled
            @change="onModelChange"
          >
            <el-option
              v-for="item in modelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="edit-device-middle-type">
          <p class="edit-device-middle-type-title"><span class="required">*</span>设备类型：</p>
          <p class="edit-device-middle-type-text">{{ deviceTypeName || '请先选择型号' }}</p>
        </div>
        <div class="edit-device-middle-sn">
          <p class="edit-device-middle-sn-title"><span class="required">*</span>设备SN：</p>
          <border-input
            class="edit-device-middle-sn-input"
            :initalValue="deviceSn"
            disabled
            @onInput="onSNInput"
          ></border-input>
        </div>
        <div v-if="showRingType" class="edit-device-middle-ring-type">
          <p class="edit-device-middle-ring-type-title"><span class="required">*</span>指环类型：</p>
          <el-radio-group v-model="ringType" class="edit-device-middle-ring-type-radio" :disabled="isOutboundViewMode">
            <el-radio :label="1">新版本(只初筛)</el-radio>
            <el-radio :label="2">老版本</el-radio>
          </el-radio-group>
        </div>
        <div class="edit-device-middle-production-date">
          <p class="edit-device-middle-production-date-title">生产日期：</p>
          <el-date-picker
            v-model="productionDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            class="edit-device-middle-production-date-picker"
            :disabled="isOutboundViewMode"
          >
          </el-date-picker>
        </div>
        <div class="edit-device-middle-expiry-date">
          <p class="edit-device-middle-expiry-date-title">有效期：</p>
          <el-date-picker
            v-model="expiryDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            class="edit-device-middle-expiry-date-picker"
            :disabled="isOutboundViewMode"
          >
          </el-date-picker>
        </div>
        <div class="edit-device-middle-batch">
          <p class="edit-device-middle-batch-title">批号：</p>
          <border-input
            class="edit-device-middle-batch-input"
            :initalValue="batchNumber"
            :disabled="isOutboundViewMode"
            @onInput="onBatchInput"
          ></border-input>
        </div>
        <div v-if="showTrafficCard" class="edit-device-middle-traffic-card">
          <p class="edit-device-middle-traffic-card-title">关联流量卡ID：</p>
          <border-input
            class="edit-device-middle-traffic-card-input"
            :initalValue="trafficCardId"
            :disabled="isOutboundViewMode"
            @onInput="onTrafficCardInput"
          ></border-input>
        </div>
        <div class="edit-device-middle-nature">
          <p class="edit-device-middle-nature-title"><span class="required">*</span>设备性质：</p>
          <el-radio-group v-model="deviceNature" class="edit-device-middle-nature-radio" :disabled="isOutboundViewMode">
            <el-radio :label="1">新设备</el-radio>
            <el-radio :label="2">流转设备</el-radio>
          </el-radio-group>
        </div>
       
        <div class="edit-device-middle-status">
          <p class="edit-device-middle-status-title">设备状态：</p>
          <el-select
            v-model="deviceStatus"
            placeholder="在库"
            disabled
            class="edit-device-middle-status-select"
          >
            <el-option label="在库" :value="1"></el-option>
            <el-option label="已售" :value="2"></el-option>
            <el-option label="流转中" :value="3"></el-option>
            <el-option label="故障维修" :value="4"></el-option>
            <el-option label="废弃" :value="5"></el-option>
            <el-option label="丢失" :value="6"></el-option>
          </el-select>
        </div>
        <div v-if="showDeviceSeries" class="edit-device-middle-series">
          <p class="edit-device-middle-series-title"><span class="required">*</span>设备系列：</p>
          <el-radio-group v-model="deviceSeries" class="edit-device-middle-series-radio" :disabled="isOutboundViewMode">
            <el-radio :label="0">M11B</el-radio>
            <el-radio :label="1">M11B Pro</el-radio>
            <el-radio :label="2">M11B Pro+</el-radio>
          </el-radio-group>
        </div>
        <div v-if="isSeniorAdministrator" class="edit-device-middle-remark">
          <p class="edit-device-middle-remark-title">备注：</p>
          <el-input
            v-model="inboundRemarks"
            type="textarea"
            placeholder="请输入备注"
            class="edit-device-middle-remark-textarea"
            :disabled="isOutboundViewMode"
            :rows="3"
          >
          </el-input>
        </div>
      </div>

      <div v-show="activeTab === 'usage'" class="edit-device-middle">
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>设备属性：</p>
            <el-select
              v-model="usageData.deviceAttribute"
              placeholder="请选择设备属性"
              class="form-field-select"
              disabled
            >
              <el-option label="正式进院" :value="1"></el-option>
              <el-option label="试用" :value="2"></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>设备状态：</p>
            <el-select
              v-model="usageData.deviceStatus"
              placeholder="请选择设备状态"
              class="form-field-select"
              disabled
            >
            <el-option label="在库" :value="1"></el-option>
             <el-option label="已售" :value="2"></el-option>
              <el-option label="流转中" :value="3"></el-option>
            <el-option label="故障维修" :value="4"></el-option>
            <el-option label="废弃" :value="5"></el-option>
            <el-option label="丢失" :value="6"></el-option>
             
            </el-select>
          </div>
        </div>

        <div class="form-row" v-if="shouldShowRings">
          <div class="form-field">
            <p class="form-field-title">同步出库指环：</p>
            <el-select
              v-model="usageData.outboundRing1"
              placeholder="请选择指环"
              class="form-field-select"
              filterable
              disabled
              clearable
            >
              <el-option
                v-for="ring in ring1List"
                :key="ring.value"
                :label="ring.label"
                :value="ring.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title">同步出库指环：</p>
            <el-select
              v-model="usageData.outboundRing2"
              placeholder="请选择指环"
              class="form-field-select"
              filterable
              disabled
              clearable
            >
              <el-option
                v-for="ring in ring2List"
                :key="ring.value"
                :label="ring.label"
                :value="ring.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>负责人：</p>
            <el-select
              v-model="usageData.outboundPersonId"
              placeholder="请选择负责人"
              class="form-field-select"
              filterable
              disabled
            >
              <el-option
                v-for="person in personList"
                :key="person.value"
                :label="person.label"
                :value="person.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title">关联机构：</p>
            <el-select
              v-model="usageData.outboundHospitalId"
              placeholder="请选择机构"
              class="form-field-select"
              filterable
              :disabled="isOutboundViewMode"
            >
              <el-option
                v-for="hospital in hospitalList"
                :key="hospital.value"
                :label="hospital.label"
                :value="hospital.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="form-row" v-if="showRingTypeInUsage">
          <div class="form-field">
            <p class="form-field-title">当前场景：</p>
            <el-select
              v-model="usageData.currentScenario"
              placeholder="当前场景"
              class="form-field-select"
              disabled
            >
              <el-option label="-" :value="0"></el-option>
              <el-option label="睡眠监测" :value="1"></el-option>
              <el-option label="初筛" :value="2"></el-option>
            </el-select>
          </div>
          <div class="form-field">
          </div>
        </div>

        <div class="form-row" v-if="usageData.deviceAttribute === 1">
          <div class="form-field">
            <p class="form-field-title">出库时间：</p>
            <el-date-picker
              v-model="usageData.outboundTime"
              type="date"
              placeholder="选择出库时间"
              value-format="yyyy-MM-dd"
              class="form-field-picker"
              :disabled="isOutboundViewMode||this.isSalesManager"
              @change="calculateContractualWarrantyPeriod"
            >
            </el-date-picker>
          </div>
          <div class="form-field">
            <p class="form-field-title">质保年数：</p>
            <el-select
              v-model="usageData.warrantyYears"
              placeholder="请选择质保年数"
              class="form-field-select"
              :disabled="isOutboundViewMode|| this.isSalesManager"
              @change="calculateContractualWarrantyPeriod"
            >
              <el-option label="1年" :value="1"></el-option>
              <el-option label="2年" :value="2"></el-option>
              <el-option label="3年" :value="3"></el-option>
              <el-option label="4年" :value="4"></el-option>
              <el-option label="5年" :value="5"></el-option>
              <el-option label="6年" :value="6"></el-option>
              <el-option label="7年" :value="7"></el-option>
              <el-option label="8年" :value="8"></el-option>
              <el-option label="9年" :value="9"></el-option>
              <el-option label="10年" :value="10"></el-option>
            </el-select>
          </div>
        </div>

        <div class="form-row" v-if="usageData.deviceAttribute === 1">
          <div class="form-field">
            <p class="form-field-title">合同质保期：</p>
            <el-date-picker
              v-model="usageData.contractualWarrantyPeriod"
              type="date"
              placeholder="合同质保期"
              value-format="yyyy-MM-dd"
              class="form-field-picker"
              disabled
            >
            </el-date-picker>
          </div>
          <div class="form-field">
          </div>
        </div>

        <div class="form-row" v-if="usageData.deviceAttribute === 1">
          <div class="form-field">
            <p class="form-field-title">关联合同编号：</p>
            <border-input
              class="form-field-input"
              :initalValue="usageData.contractNumber"
              :disabled="isOutboundViewMode || this.isSalesManager"
              @onInput="onContractNumberInput"
            ></border-input>
          </div>
          <div class="form-field">
            <p class="form-field-title">签订合同对象：</p>
            <border-input
              class="form-field-input"
              :initalValue="usageData.contractSignatory"
              :disabled="isOutboundViewMode || this.isSalesManager"
              @onInput="onContractSignatoryInput"
            ></border-input>
          </div>
        </div>

        <div class="form-row" v-if="showTrafficCardWarrantyFields">
          <div class="form-field">
            <p class="form-field-title">流量卡到期日期：</p>
            <el-date-picker
              v-model="usageData.trafficCardExpiryDate"
              type="date"
              placeholder="选择流量卡到期日期"
              value-format="yyyy-MM-dd"
              class="form-field-picker"
              :disabled="isTrafficCardWarrantyDisabled"
            >
            </el-date-picker>
          </div>
          <div class="form-field">
          </div>
        </div>

        <div class="form-row" v-if="showTrafficCardWarrantyFields">
          <div class="form-field">
            <p class="form-field-title">流量卡备注：</p>
            <el-input
              v-model="usageData.trafficCardRemarks"
              type="textarea"
              placeholder="请输入流量卡备注"
              class="form-field-textarea"
              :disabled="isTrafficCardWarrantyDisabled"
              :rows="2"
            >
            </el-input>
          </div>
        </div>

        <div v-if="isSeniorAdministrator && usageData.deviceAttribute === 1" class="form-row">
          <div class="form-field">
            <p class="form-field-title">备注：</p>
            <el-input
              v-model="usageData.outboundRemarks"
              type="textarea"
              placeholder="请输入备注"
              class="form-field-textarea"
              :disabled="isOutboundViewMode"
              :rows="2"
            >
            </el-input>
          </div>
        </div>

        <div v-if="!hasUsageData" class="no-usage-data">
          <p>暂无使用档案</p>
        </div>
      </div>

      <div class="edit-device-bottom">
        <button v-if="bottomButtonConfig.showCancel" class="edit-device-bottom-cancel" @click="onCancelClick">取消</button>
        <button v-if="bottomButtonConfig.showConfirm" class="edit-device-bottom-confirm" @click="onConfirmClick">确定</button>
       
        <button v-if="bottomButtonConfig.showLost" class="edit-device-bottom-lost" @click="onLostClick">丢失</button>
        <button v-if="bottomButtonConfig.showDiscard" class="edit-device-bottom-discard" @click="onDiscardClick">废弃</button>
        
        
        <!-- 质检开关：仅在设备基础信息tab且设备状态为在库(1)且用户为高级管理员且为特定设备型号时显示 -->
        <el-switch
            v-if="activeTab === 'basic' && deviceStatus === 1 && $store.getters.isSeniorAdministrator && shouldShowQualitySwitch"
            v-model="qualityInspectionSwitchStatus"
            active-text="开启质检"
            inactive-text="关闭质检"
            active-color="#325FAC"
            inactive-color="#999999"
            class="quality-inspection-switch"
            @change="onQualityInspectionSwitchChange"
          />
        
        <!-- 质检录入按钮：仅在设备基础信息tab且在库状态且高级管理员时显示，特定型号需要开关开启，其他型号直接显示 -->
        <button 
          v-if="activeTab === 'basic' && deviceStatus === 1 && $store.getters.isSeniorAdministrator && (shouldShowQualitySwitch ? qualityInspectionSwitchStatus : true)" 
          class="edit-device-bottom-discard" 
          @click="onQualityInspectionClick">质检录入
        </button>
        
        <button v-if="bottomButtonConfig.showEdit" class="edit-device-bottom-edit" @click="onEditClick">编辑</button>
      </div>
    </div>

    <!-- 丢失确认弹框 -->
    <el-dialog
      title="丢失确认"
      :visible.sync="showLostDialog"
      width="480px"
      class="lost-dialog"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :destroy-on-close="true"
      :append-to-body="true"
      @close="onCloseLostDialog"
      @closed="onDialogClosed"
    >
      <el-form :model="lostForm" label-width="100px" label-position="left">
        <el-form-item label="状态：" class="switch-form-item">
          <el-switch
            v-model="lostForm.lost"
            active-text="丢失"
            inactive-text="找回"
            active-color="#325FAC"
            inactive-color="#2ed573"
          />
        </el-form-item>
        
        <el-form-item 
          v-if="lostForm.lost" 
          label="丢失说明："
          :rules="[{ required: true, message: '请填写丢失说明', trigger: 'blur' }]"
          prop="lostReason"
          class="textarea-form-item"
        >
          <el-input
            v-model="lostForm.lostReason"
            type="textarea"
            placeholder="请输入丢失说明"
            :rows="3"
          />
        </el-form-item>
        
        <el-form-item 
          v-if="!lostForm.lost" 
          label="设备状态："
          class="select-form-item"
        >
          <el-select
            v-model="lostForm.status"
            placeholder="请选择设备状态"
            style="width: 100%"
          >
            <el-option label="在库" :value="1"></el-option>
            <el-option label="流转中" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseLostDialog">取消</el-button>
        <el-button type="primary" @click="onConfirmLost">确定</el-button>
      </span>
    </el-dialog>

    <!-- 废弃确认弹框 -->
    <el-dialog
      title="废弃确认"
      :visible.sync="showDiscardDialog"
      width="480px"
      class="discard-dialog"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :destroy-on-close="true"
      :append-to-body="true"
      @close="onCloseDiscardDialog"
      @closed="onDialogClosed"
    >
      <el-form :model="discardForm" label-width="100px" label-position="left">
        <el-form-item 
          label="废弃说明："
          :rules="[{ required: true, message: '请填写废弃说明', trigger: 'blur' }]"
          prop="scrapReason"
          class="textarea-form-item"
        >
          <el-input
            v-model="discardForm.scrapReason"
            type="textarea"
            placeholder="请输入废弃说明"
            :rows="3"
          />
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseDiscardDialog">取消</el-button>
        <el-button type="primary" @click="onConfirmDiscard">确定</el-button>
      </span>
    </el-dialog>

    <!-- 质检录入弹框 -->
    <quality-inspection-entry
      :visible="showQualityInspectionDialog"
      :deviceData="model"
      @close="onCloseQualityInspectionDialog"
      @submit="onQualityInspectionSubmit"
      @submitComplete="onQualityInspectionSubmitComplete"
      @openFaultDialog="onOpenFaultDialog"
    />

    <!-- 故障处理弹框 -->
    <equipment-failure
      v-if="showEquipmentFailureDialog"
      :deviceData="model"
      :hospitalList="hospitalList"
      @onCloseClick="onCloseEquipmentFailureDialog"
      @onSubmitFailure="onSubmitFailure"
    />
  </pop-view>
</template>

<script>
import PopView from "@c/common/pop-view.vue";
import BorderInput from "@c/common/border-input.vue";
import QualityInspectionEntry from "./quality-inspection-entry.vue";
import EquipmentFailure from "./equipment-failure.vue";
import { Select, Option, DatePicker, RadioGroup, Radio, Input, Dialog, Button, Switch, Form, FormItem } from "element-ui";

export default {
  components: {
    PopView,
    BorderInput,
    QualityInspectionEntry,
    EquipmentFailure,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker,
    ElRadioGroup: RadioGroup,
    ElRadio: Radio,
    ElInput: Input,
    ElDialog: Dialog,
    ElButton: Button,
    ElSwitch: Switch,
    ElForm: Form,
    ElFormItem: FormItem,
  },

  props: {
    model: Object,
    viewMode: {
      type: Boolean,
      default: false
    },
    isSeniorAdministrator: {
      type: Boolean,
      default: false
    },
  },

  data: function () {
    return {
      activeTab: 'basic',
      selectedModelId: "",
      modelValue: "",
      deviceTypeName: "",
      deviceTypeId: "",
      deviceCategory: null,
      deviceSn: "",
      ringType: 1,
      productionDate: "",
      expiryDate: "",
      batchNumber: "",
      trafficCardId: "",
      deviceNature: 1,
      deviceSeries: 0,
      deviceStatus: 1,
      inboundRemarks: "",
      modelList: [],
      isOutboundViewMode: false,
      usageData: {
        deviceAttribute: null,
        deviceStatus: null,
        outboundRing1: null,
        outboundRing2: null,
        outboundPersonId: null,
        outboundHospitalId: null,
        currentScenario: null,
        outboundTime: "",
        warrantyYears: null,
        contractualWarrantyPeriod: "",
        contractNumber: "",
        contractSignatory: "",
        outboundRemarks: "",
        trafficCardExpiryDate: "",
        trafficCardRemarks: "",
      },
      personList: [],
      hospitalList: [],
      ring1List: [],
      ring2List: [],
      
      hasUsageData: false,
      
      // 丢失弹框相关数据
      showLostDialog: false,
      lostForm: {
        lost: false, // 默认关闭质检状态
        lostReason: '',
        status: 1
      },
      
      // 废弃弹框相关数据
      showDiscardDialog: false,
      discardForm: {
        scrapReason: ''
      },
      
      // 质检录入弹框相关数据
      showQualityInspectionDialog: false,
      
      // 质检开关状态
      qualityInspectionSwitchStatus: false,
      
      // 故障处理弹框相关数据
      showEquipmentFailureDialog: false,
    };
  },

  computed: {
    isSalesManager() {
      return this.$store.getters.isSalesManager;
    },
    showRingType() {
      return this.deviceCategory === 2;
    },
    showTrafficCard() {
      return this.deviceCategory !== 2 && this.deviceCategory !== null;
    },
    shouldShowRings() {
      return this.model && this.model.model === 'ZG-S01D';
    },
    showRingTypeInUsage() {
      return this.deviceCategory === 2;
    },
    // 判断是否显示设备系列字段（只有ZG-M11B型号id为3时显示）
    showDeviceSeries() {
      return this.selectedModelId === 3;
    },
    // 判断是否需要显示质检开关的设备型号
    shouldShowQualitySwitch() {
      const specialModelIds = [1, 3, 7, 8, 9, 10, 11, 12, 13, 14];
      return specialModelIds.includes(this.selectedModelId);
    },
    showTrafficCardWarrantyFields() {
      // 正式进院且非指环（deviceCategory === 2 为指环，如 P11）才显示流量卡字段
      return this.usageData.deviceAttribute === 1 && this.deviceCategory !== 2;
    },
    isTrafficCardWarrantyDisabled() {
      return this.isOutboundViewMode || !this.isSeniorAdministrator;
    },
    // 检查当前tab是否允许编辑
    isCurrentTabEditable() {
      if (this.activeTab === 'basic') {
        // 设备基础信息tab：在查看模式下不可编辑
        return !this.isOutboundViewMode;
      } else if (this.activeTab === 'usage') {
        // 使用档案tab：只有正式进院设备且管理员权限才可编辑
        return !this.isOutboundViewMode && this.isSeniorAdministrator && this.usageData.deviceAttribute === 1;
      }
      return false;
    },
    // 获取底部按钮显示状态
    bottomButtonConfig() {
      if (this.isOutboundViewMode) {
        // 查看模式
        if (this.activeTab === 'basic') {
          // 基础信息tab：查看模式下显示编辑、丢失、废弃按钮（如果有权限）
          return {
            showEdit: this.isSeniorAdministrator,
            showCancel: false,
            showConfirm: false,
            showLost: this.isSeniorAdministrator,
            showDiscard: this.isSeniorAdministrator
          };
        } else if (this.activeTab === 'usage') {
          // 使用档案tab：管理员权限或销售经理都可以显示编辑按钮
          return {
            showEdit: (this.isSeniorAdministrator || this.isSalesManager) && this.usageData.deviceAttribute === 1,
            showCancel: false,
            showConfirm: false,
            showLost: false,
            showDiscard: false
          };
        }
      } else {
        // 编辑模式
        return {
          showEdit: false,
          showCancel: true,
          showConfirm: (this.activeTab === 'basic' && !this.isSalesManager) || 
                       (this.activeTab === 'usage' && (this.isSeniorAdministrator || this.isSalesManager)),
          showLost: false,
          showDiscard: false
        };
      }
      
      // 默认返回值
      return {
        showEdit: false,
        showCancel: false,
        showConfirm: false,
        showLost: false,
        showDiscard: false
      };
    }
  },

  async mounted() {
    await this.getModelList();
    await this.getPersonList();
    await this.getHospitalList();
    await this.getRingList();
    this.initializeData();
    this.isOutboundViewMode = this.viewMode;
    await this.loadUsageData();
  },

  methods: {
    async getModelList() {
      try {
        const response = await this.$api.getDeviceTypesList({});
        this.modelList = response.map(item => ({
          value: item.id,
          label: item.model,
          typeName: item.typeName,
          deviceCategory: item.deviceCategory
        }));
      } catch (error) {
        console.error('获取设备型号列表失败:', error);
      }
    },

    async getPersonList() {
      try {
        const response = await this.$api.getResponsiblePersonList();
        this.personList = response.map(item => ({
          value: item.id,
          label: item.trueName
        }));
      } catch (error) {
        console.error('获取负责人列表失败:', error);
      }
    },

    async getHospitalList() {
      try {
        const params = {
          parentId: this.$store.state.accountInfo.id
        };
        const response = await this.$api.getHospitalList(params);
        this.hospitalList = response.map(item => ({
          value: item.id,
          label: item.hospitalName
        }));
      } catch (error) {
        console.error('获取机构列表失败:', error);
      }
    },

    async getRingList() {
      try {
        const response = await this.$api.getRingDeviceList({
          deviceStatus: 3,
          deviceNature: 2
        });
        const ringData = response.map(item => ({
          value: item.id,
          label: item.deviceSn,
          deviceSn: item.deviceSn,
          deviceHospitalName: item.deviceHospitalName
        }));
        this.ring1List = ringData;
        this.ring2List = ringData;
      } catch (error) {
        console.error('获取指环列表失败:', error);
      }
    },

    async loadUsageData() {
      if (!this.model) {
        return;
      }
      
      try {
        const hasOutboundData = this.model.deviceAttribute || 
                               this.model.outboundPersonId || 
                               this.model.outboundHospitalId ||
                               this.model.outboundTime;
        
        if (hasOutboundData) {
          this.hasUsageData = true;
          this.usageData = {
            deviceAttribute: this.model.deviceAttribute || null,
            deviceStatus: this.model.deviceStatus || null,
            outboundRing1: this.model.outboundRing1 || null,
            outboundRing2: this.model.outboundRing2 || null,
            outboundPersonId: this.model.outboundPersonId || null,
            outboundHospitalId: this.model.outboundHospitalId || null,
            currentScenario: this.model.currentScenario || null,
            outboundTime: this.model.outboundTime || "",
            warrantyYears: this.model.warrantyYears || null,
            contractualWarrantyPeriod: this.model.contractualWarrantyPeriod || "",
            contractNumber: this.model.contractNumber || "",
            contractSignatory: this.model.contractSignatory || "",
            outboundRemarks: this.model.outboundRemarks || "",
            trafficCardExpiryDate: this.model.trafficCardExpiryDate || "",
            trafficCardRemarks: this.model.trafficCardRemarks || "",
          };
          this.initializeRingSelections();
          this.calculateContractualWarrantyPeriod();
        } else {
          this.hasUsageData = false;
        }
      } catch (error) {
        console.error('获取使用档案数据失败:', error);
        this.hasUsageData = false;
      }
    },

    initializeData() {
      this.deviceSn = this.model.deviceSn || '';
      this.ringType = this.model.ringType || 1;
      this.productionDate = this.model.productionDate || '';
      this.expiryDate = this.model.expiryDate || '';
      this.batchNumber = this.model.batchNumber || '';
      this.trafficCardId = this.model.trafficCardId || '';
      this.deviceNature = this.model.deviceNature || 1;
      this.deviceSeries = this.model.deviceSeries || 0;
      this.deviceStatus = this.model.deviceStatus || 1;
      this.inboundRemarks = this.model.inboundRemarks || '';
      
      // 根据接口返回的qualityCheckSwitch设置质检开关初始状态
      // 0表示关闭，1表示开启
      this.qualityInspectionSwitchStatus = this.model.qualityCheckSwitch === 1;
      
      if (this.model.model) {
        const selectedModel = this.modelList.find(item => item.label === this.model.model);
       
        if (selectedModel) {
          this.selectedModelId = selectedModel.value;
          this.deviceTypeName = selectedModel.typeName;
          this.deviceTypeId = selectedModel.value;
          this.modelValue = selectedModel.label;
          this.deviceCategory = selectedModel.deviceCategory;
        }
      }
    },

    onModelChange(value) {
      const selectedModel = this.modelList.find(item => item.value === value);
      this.deviceTypeName = selectedModel ? selectedModel.typeName : '';
      this.deviceTypeId = selectedModel ? selectedModel.value : '';
      this.modelValue = selectedModel ? selectedModel.label : '';
      this.deviceCategory = selectedModel ? selectedModel.deviceCategory : null;
    },

    onSNInput: function (value) {
      this.deviceSn = value;
    },

    onBatchInput: function (value) {
      this.batchNumber = value;
    },

    onTrafficCardInput: function (value) {
      this.trafficCardId = value;
    },

    onContractNumberInput: function (value) {
      this.usageData.contractNumber = value;
    },

    onContractSignatoryInput: function (value) {
      this.usageData.contractSignatory = value;
    },

    calculateContractualWarrantyPeriod: function() {
      if (this.usageData.outboundTime && this.usageData.warrantyYears) {
        try {
          const outboundDate = new Date(this.usageData.outboundTime);
          const warrantyEndDate = new Date(outboundDate);
          warrantyEndDate.setFullYear(outboundDate.getFullYear() + this.usageData.warrantyYears);
          
          const year = warrantyEndDate.getFullYear();
          const month = String(warrantyEndDate.getMonth() + 1).padStart(2, '0');
          const day = String(warrantyEndDate.getDate()).padStart(2, '0');
          
          this.usageData.contractualWarrantyPeriod = `${year}-${month}-${day}`;
        } catch (error) {
          console.error('计算合同质保期失败:', error);
          this.usageData.contractualWarrantyPeriod = "";
        }
      } else {
        this.usageData.contractualWarrantyPeriod = "";
      }
    },

    onCloseClick: function () {
      this.$emit("onCloseClick");
    },

    onCancelClick: function () {
      this.onCloseClick();
    },

    onConfirmClick: function () {
      if (this.activeTab === 'basic') {
        // 设备基础信息编辑
        if (!this.selectedModelId) {
          this.$toast.showRed("请选择型号");
          return;
        }
        if (this.deviceSn.length === 0) {
          this.$toast.showRed("请输入设备SN");
          return;
        }
        if (this.showRingType && !this.ringType) {
          this.$toast.showRed("请选择指环类型");
          return;
        }
        if (!this.deviceNature) {
          this.$toast.showRed("请选择设备性质");
          return;
        }
        if (this.showDeviceSeries && this.deviceSeries === null) {
          this.$toast.showRed("请选择设备系列");
          return;
        }
        
        this.$emit("onConfirmClick", {
          id: this.model.id,
          model: this.modelValue,
          deviceTypeId: this.deviceTypeId,
          deviceSn: this.deviceSn,
          ringType: this.ringType,
          productionDate: this.productionDate,
          expiryDate: this.expiryDate,
          batchNumber: this.batchNumber,
          trafficCardId: this.trafficCardId,
          deviceNature: this.deviceNature,
          deviceSeries: this.deviceSeries,
          deviceStatus: this.deviceStatus,
          inboundRemarks: this.inboundRemarks,
        });
      } else if (this.activeTab === 'usage') {
        // 验证两个同步出库指环值不能相同
        if (this.usageData.outboundRing1 && this.usageData.outboundRing2 && this.usageData.outboundRing1 === this.usageData.outboundRing2) {
          this.$toast.showRed("两个同步出库指环值需要不相同");
          return;
        }
        let outboundRingIds = '';
        if (this.model && 
            this.model.syncOutboundRingHospitals && 
            Array.isArray(this.model.syncOutboundRingHospitals)) {
          const ringHospitals = this.model.syncOutboundRingHospitals;
          outboundRingIds = [ringHospitals[0]?.id, ringHospitals[1]?.id].filter(id => !!id).join(',');
        }

        const payload = {
          id: this.model.id,
          deviceAttribute: this.usageData.deviceAttribute,
          deviceStatus: this.usageData.deviceStatus,
          outboundPersonId: this.usageData.outboundPersonId,
          outboundHospitalId: this.usageData.outboundHospitalId,
          outboundTime: this.usageData.outboundTime,
          warrantyYears: this.usageData.warrantyYears,
          contractNumber: this.usageData.contractNumber,
          contractSignatory: this.usageData.contractSignatory,
          outboundRemarks: this.usageData.outboundRemarks,
          outboundRingIds: outboundRingIds,
        };

        if (this.showTrafficCardWarrantyFields) {
          payload.updateTrafficCardWarranty = true;
          payload.trafficCardExpiryDate = this.usageData.trafficCardExpiryDate || null;
          payload.trafficCardRemarks = this.usageData.trafficCardRemarks || "";
        }

        // 使用档案（出库信息）编辑
        this.$emit("onConfirmClick", payload);
      }
    },

    onLostClick: function () {
      // 重置表单数据
      this.lostForm = {
        lost: true,
        lostReason: '',
        status: 1
      };
      this.showLostDialog = true;
    },

    onCloseLostDialog: function () {
      this.showLostDialog = false;
      // 重置表单数据
      this.lostForm = {
        lost: true,
        lostReason: '',
        status: 1
      };
      
      // 强制清理遮罩层
      this.$nextTick(() => {
        const modals = document.querySelectorAll('.el-dialog__wrapper');
        modals.forEach(modal => {
          if (modal && modal.style.display !== 'none' && !modal.querySelector('.edit-device')) {
            modal.style.display = 'none';
            modal.remove();
          }
        });
        
        // 清理body上的overflow样式
        document.body.style.overflow = '';
        document.body.classList.remove('el-popup-parent--hidden');
      });
    },

    onDialogClosed: function() {
      // 弹框完全关闭后的额外清理
      this.$nextTick(() => {
        // 确保移除所有残留的遮罩层
        const overlays = document.querySelectorAll('.v-modal');
        overlays.forEach(overlay => {
          if (overlay && overlay.parentNode) {
            overlay.parentNode.removeChild(overlay);
          }
        });
        
        // 恢复body滚动
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('el-popup-parent--hidden');
      });
    },

    async onConfirmLost() {
      try {
        // 表单验证
        if (this.lostForm.lost && !this.lostForm.lostReason.trim()) {
          this.$toast.showRed("请填写丢失说明");
          return;
        }

        const params = {
          id: this.model.id,
        };

        if (this.lostForm.lost) {
          // 丢失状态：调用 getSleepDeviceArchivesLoss 接口
          params.lostReason = this.lostForm.lostReason;
          await this.$api.getSleepDeviceArchivesLoss(params);
          this.$toast.showGreen("设备丢失标记成功");
        } else {
          
          if (this.lostForm.status) {
            params.deviceStatus = this.lostForm.status;
          }
          await this.$api.getSleepDeviceArchivesRecover(params);
          this.$toast.showGreen("设备找回成功");
        }
        this.onCloseClick();
        // 关闭弹框并重置数据
        this.onCloseLostDialog();
        // 触发父组件刷新列表，使用新的事件名称
        this.$emit("onLostComplete", this.model);
      } catch (error) {
        console.error('操作失败:', error);
        this.$toast.showRed(error || "操作失败");
      }
    },

    onDiscardClick: function () {
      // 重置表单数据
      this.discardForm = {
        scrapReason: ''
      };
      this.showDiscardDialog = true;
    },

    onCloseDiscardDialog: function () {
      this.showDiscardDialog = false;
      // 重置表单数据
      this.discardForm = {
        scrapReason: ''
      };
      
      // 强制清理遮罩层
      this.$nextTick(() => {
        const modals = document.querySelectorAll('.el-dialog__wrapper');
        modals.forEach(modal => {
          if (modal && modal.style.display !== 'none' && !modal.querySelector('.edit-device')) {
            modal.style.display = 'none';
            modal.remove();
          }
        });
        
        // 清理body上的overflow样式
        document.body.style.overflow = '';
        document.body.classList.remove('el-popup-parent--hidden');
      });
    },

    async onConfirmDiscard() {
      try {
        // 表单验证
        if (!this.discardForm.scrapReason.trim()) {
          this.$toast.showRed("请填写废弃说明");
          return;
        }

        const params = {
          id: this.model.id,
          scrapReason: this.discardForm.scrapReason
        };

        // 调用 getSleepDeviceArchivesAbandon 接口
        await this.$api.getSleepDeviceArchivesAbandon(params);
        this.$toast.showGreen("设备废弃成功");
        
        this.onCloseClick();
        // 关闭弹框并重置数据
        this.onCloseDiscardDialog();
        // 触发父组件刷新列表
        this.$emit("onLostComplete", this.model);
      } catch (error) {
        console.error('废弃操作失败:', error);
        this.$toast.showRed(error || "废弃操作失败");
      }
    },

    onEditClick: function () {
      this.isOutboundViewMode = false;
    },

    onQualityInspectionClick: function () {
      this.showQualityInspectionDialog = true;
    },

    onCloseQualityInspectionDialog: function () {
      this.showQualityInspectionDialog = false;
    },

    async onQualityInspectionSubmit(submitData) {
      try {
       
        
        // 调用质检完成接口
        const params = {
          id: submitData.deviceId,
          qualityInspectionType: submitData.inspectionType,
          qualityInspectionRecord: submitData.inspectionRecord,
          qualityInspectionImages: submitData.inspectionImages
        };
        
        await this.$api.completeQualityInspection(params);
        
        this.$toast.showGreen("质检完成成功");
        this.onCloseQualityInspectionDialog();
        // 触发父组件刷新列表
        this.$emit("onLostComplete", this.model);
        // 质检完成后自动关闭设备档案窗口
        this.onCloseClick();
      } catch (error) {
        console.error('质检完成失败:', error);
        this.$toast.showRed(error || "质检完成失败");
      }
    },

    onQualityInspectionSubmitComplete(submitData) {
      // 质检录入组件直接调用API成功后触发此事件
      // 关闭质检录入弹框
      this.onCloseQualityInspectionDialog();
      // 触发父组件刷新列表
      this.$emit("onLostComplete", this.model);
      // 质检完成后自动关闭设备档案窗口
      this.onCloseClick();
    },

    onOpenFaultDialog(deviceData) {
      // 打开故障处理弹框，默认进入"提交故障"tab
      this.showEquipmentFailureDialog = true;
    },

    onCloseEquipmentFailureDialog() {
      this.showEquipmentFailureDialog = false;
    },

    async onSubmitFailure(data) {
      try {
        console.log('故障提交数据:', data);
        
        // 调用故障提交接口
        const params = {
          deviceId: data.deviceId,
          associatedInstitutionId: data.associatedInstitutionId,
          processingDetails: data.processingDetails,
          deviceSn: data.deviceSn,
          faultOrderStatus: 1,
          faultImages: data.faultImages || ''
        };
        
        await this.$api.getSleepDeviceMaintenanceOrderSave(params);
        
        this.$toast.showGreen("故障提交成功");
        this.onCloseEquipmentFailureDialog();
        // 触发父组件刷新列表
        this.$emit("onLostComplete", this.model);
      } catch (error) {
        console.error('故障提交失败:', error);
        this.$toast.showRed(error || "故障提交失败");
      }
    },

    initializeRingSelections() {
      // 如果model中有syncOutboundRingHospitals且是数组
      if (this.model && 
          this.model.syncOutboundRingHospitals && 
          Array.isArray(this.model.syncOutboundRingHospitals)) {
        const ringHospitals = this.model.syncOutboundRingHospitals;
        this.usageData.outboundRing1 = ringHospitals[0]?.ringSn;
        this.usageData.outboundRing2 = ringHospitals[1]?.ringSn;
      }
    },

    async onQualityInspectionSwitchChange(value) {
      try {
        const params = {
          id: this.model.id
        };

        if (value) {
          // 开启质检
          await this.$api.enableQualityInspection(params);
          this.$toast.showGreen("质检开启成功");
        } else {
          // 关闭质检
          await this.$api.closeQualityInspection(params);
          this.$toast.showGreen("质检关闭成功");
        }
        
        // 质检开关成功后，触发父组件刷新列表数据
        this.$emit("onLostComplete", this.model);
      } catch (error) {
        console.error('质检开关操作失败:', error);
        this.$toast.showRed(error || "质检开关操作失败");
        // 操作失败时恢复开关状态
        this.qualityInspectionSwitchStatus = !value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-device {
  width: rem(650);

  &-top {
    width: 100%;
    height: rem(55);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    box-sizing: border-box;
    padding: rem(0) rem(24);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(16);
    }

    &-close {
      width: rem(16);
      height: rem(16);
    }
  }

  // Tab 标签页样式
  &-tabs {
    width: 100%;
    display: flex;
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    
    .tab-item {
      flex: 1;
      height: rem(45);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: rem(14);
      color: rgba($color: black, $alpha: 0.65);
      cursor: pointer;
      position: relative;
      transition: color 0.3s;
      
      &:hover {
        color: rgba($color: black, $alpha: 0.85);
      }
      
      &.active {
        color: #325FAC;
        font-weight: 500;
        
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: rem(2);
          background-color: #325FAC;
        }
      }
    }
  }

  &-middle {
    color: rgba($color: black, $alpha: 0.85);
    font-size: rem(14);
    line-height: rem(20);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    width: 100%;
    max-height: rem(600);
    overflow-y: auto;
    padding: rem(20) rem(24);
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: rem(16) rem(20);

    .required {
      color: #ff4d4f;
    }

    &-model {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-select {
        ::v-deep .el-input {
          height: rem(32);
        }
      }
    }

    &-type {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-text {
        height: rem(32);
        line-height: rem(32);
        padding: 0 rem(8);
        background-color: #f5f5f5;
        border: 1px solid #e8e8e8;
        border-radius: rem(4);
        color: rgba($color: black, $alpha: 0.65);
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    &-sn {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-input {
        height: rem(32);
      }
    }

    &-ring-type {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-radio {
        ::v-deep .el-radio {
          margin-right: rem(16);
        }
      }
    }

    &-production-date {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-picker {
        ::v-deep .el-input {
          height: rem(32);
        }
      }
    }

    &-expiry-date {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-picker {
        ::v-deep .el-input {
          height: rem(32);
        }
      }
    }

    &-batch {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-input {
        height: rem(32);
      }
    }

    &-traffic-card {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-input {
        height: rem(32);
      }
    }

    &-nature {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-radio {
        ::v-deep .el-radio {
          margin-right: rem(16);
        }
      }
    }

    &-series {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-radio {
        ::v-deep .el-radio {
          margin-right: rem(16);
        }
      }
    }

    &-status {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-select {
        ::v-deep .el-input {
          height: rem(32);
          background-color: #f5f5f5;
        }
      }
    }

    &-remark {
      grid-column: 1 / -1;
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-textarea {
        ::v-deep .el-textarea__inner {
          min-height: rem(80);
        }
      }
    }

    // 使用档案相关样式 
    .form-row {
      display: flex;
      gap: rem(20);
      margin-bottom: rem(16);
      grid-column: 1 / -1;

      .form-field {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: rem(8);

        &-title {
          font-weight: 500;
          margin: 0;
        }

        &-select,
        &-picker {
          ::v-deep .el-input {
            height: rem(32);
          }
        }

        &-input {
          height: rem(32);
        }

        &-textarea {
          ::v-deep .el-textarea__inner {
            min-height: rem(80);
          }
        }
      }
    }

    .no-usage-data {
      grid-column: 1 / -1;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: rem(200);
      color: #999999;
      
      p {
        margin: 0;
        font-size: rem(14);
      }
    }
  }

  &-bottom {
    width: 100%;
    height: rem(73);
    box-sizing: border-box;
    padding-top: rem(10);
    padding-right: rem(16);
    display: flex;
    justify-content: flex-end;

    &-confirm {
      color: white;
      background-color: #325FAC;
      font-size: rem(14);
      border-radius: rem(3);
      width: rem(65);
      height: rem(32);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-cancel {
      color: rgba($color: #000000, $alpha: 0.65);
      background-color: white;
      font-size: rem(14);
      border-radius: rem(3);
      border: rem(1) solid #e8e8e8;
      width: rem(65);
      height: rem(32);
      margin-right: rem(8);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-lost {
      color: rgba($color: #000000, $alpha: 0.65);
      background-color: white;
     
      font-size: rem(14);
      border-radius: rem(3);
      border: rem(1) solid #e8e8e8;
      width: rem(65);
      height: rem(32);
      margin-right: rem(8);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-discard {
      color: rgba($color: #000000, $alpha: 0.65);
      background-color: white;
     
      font-size: rem(14);
      border-radius: rem(3);
      border: rem(1) solid #e8e8e8;
      width: rem(65);
      height: rem(32);
      margin-right: rem(8);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-edit {
      color: white;
      background-color: #325FAC;
      font-size: rem(14);
      border-radius: rem(3);
      width: rem(65);
      height: rem(32);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

// 质检开关样式
.quality-inspection-switch {
  margin-right: rem(8);
  display: flex;
  align-items: center;
  height: rem(32);

  ::v-deep {
    .el-switch__label {
      font-size: rem(14);
      color: rgba($color: black, $alpha: 0.65);
      
      &.is-active {
        color: rgba($color: black, $alpha: 0.85);
      }
    }
    
    .el-switch__core {
      height: rem(20);
      line-height: rem(20);
      
      .el-switch__button {
        width: rem(16);
        height: rem(16);
        top: rem(2);
      }
    }
  }
}

// 丢失确认弹框样式
::v-deep .lost-dialog,
::v-deep .discard-dialog {
  .el-dialog__header {
    background-color: #f8f9fa;
    border-bottom: rem(1) solid #e8e8e8;
    padding: rem(20) rem(24);

    .el-dialog__title {
      font-size: rem(16);
      font-weight: 500;
      color: rgba($color: black, $alpha: 0.85);
    }
  }

  .el-dialog__body {
    padding: rem(24);
  }

  .el-form {
    .el-form-item {
      margin-bottom: rem(24);
      
      &:last-child {
        margin-bottom: 0;
      }

      // 状态行和其他行之间的间距更大
      &.switch-form-item {
        margin-bottom: rem(36);
      }

      .el-form-item__label {
        font-size: rem(14);
        font-weight: 500;
        color: rgba($color: black, $alpha: 0.85);
        line-height: rem(32);
        padding: 0 rem(12) 0 0;
      }

      .el-form-item__content {
        line-height: rem(32);
      }

      // textarea表单项对齐调整
      &.textarea-form-item {
        .el-form-item__label {
          line-height: rem(20);
          padding-top: rem(6);
        }
      }

      .el-switch {
        .el-switch__label {
          color: rgba($color: black, $alpha: 0.65);
          font-size: rem(14);
          
          &.is-active {
            color: rgba($color: black, $alpha: 0.85);
            font-weight: 500;
          }
        }
      }

      .el-input {
        .el-input__inner {
          border-radius: rem(6);
          border: rem(1) solid #e1e5e9;
          transition: border-color 0.2s, box-shadow 0.2s;

          &:focus {
            border-color: #325FAC;
            box-shadow: 0 0 0 rem(2) rgba(50, 95, 172, 0.1);
          }

          &:hover {
            border-color: #325FAC;
          }
        }
      }

      .el-textarea {
        .el-textarea__inner {
          border-radius: rem(6);
          border: rem(1) solid #e1e5e9;
          font-family: inherit;
          resize: none;
          transition: border-color 0.2s, box-shadow 0.2s;

          &:focus {
            border-color: #325FAC;
            box-shadow: 0 0 0 rem(2) rgba(50, 95, 172, 0.1);
          }

          &:hover {
            border-color: #325FAC;
          }
        }
      }

      .el-select {
        width: 100%;
        
        .el-input__inner {
          border-radius: rem(6);
          border: rem(1) solid #e1e5e9;
          transition: border-color 0.2s, box-shadow 0.2s;

          &:focus {
            border-color: #325FAC;
            box-shadow: 0 0 0 rem(2) rgba(50, 95, 172, 0.1);
          }

          &:hover {
            border-color: #325FAC;
          }
        }
      }
    }
  }

  .dialog-footer {
    text-align: right;
    padding: rem(16) rem(24) rem(24);
    border-top: rem(1) solid #e8e8e8;

    .el-button {
      margin-left: rem(12);
      border-radius: rem(6);
      font-size: rem(14);
      padding: rem(10) rem(24);
      font-weight: 500;

      &:first-child {
        margin-left: 0;
      }

      &--primary {
        background-color: #325FAC;
        border-color: #325FAC;

        &:hover {
          background-color: #2a4f96;
          border-color: #2a4f96;
        }
      }
    }
  }
}
</style>
